import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

export const StyledLightningLinkCasino = styled.div`
  box-sizing: border-box;
  font-family: ${(props: any) => props.fontFamily};
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 8px;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  padding: 4px 8px 5px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 6px 4px 0px rgba(255, 255, 255, 0.3) inset;

  .tooltip-icon {
    height: 24px;
  }

  .lightning-link-bundle {
    &__emblem-badge {
      position: absolute;
      left: 0;
      background-image: url(${(props: any) => props.badgeImage});
      background-repeat: no-repeat;
      z-index: 1000;
      height: 32px;

      @media (width <= ${breakpoints.mobileM}) {
        top: 5px;
        height: 28px;
      }

      img {
        max-height: 100%;
      }
    }

    &__tooltip {
      position: absolute;
      right: 8px;
      margin-top: 2px;

      .tooltip-container {
        height: 100%;
      }
    }

    &__products-container {
      position: relative;
      top: -10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      gap: 10px;
      justify-content: center;
    }
  }
` as any;

export const StyledRibbonWithImage = styled.div`
  position: absolute;
  left: -10px;
  top: -10px;
  z-index: 1000;
  height: 54px;

  img {
    max-height: 100%;
  }

  .ribbon-title {
    position: absolute;
    top: 23px;
    right: -26px;
    width: 100px;
    text-align: center;
    font-size: 10px;
    font-weight: 700;
    transform: rotate(-5.5deg);
    color: ${(props: any) => createGradientOrSolid(props.color)};
  }
` as any;
